import { APIForVolunteerV3V2 } from ".";

export const getAllBrancheLocations = (langNumber) =>
  APIForVolunteerV3V2.get(`brnch_info?lang=${langNumber}`);
export const getAboutUs = (langNumber) =>
  APIForVolunteerV3V2.get(`about_us?language=${langNumber}`);
